<template lang='pug'>
	.the-map
		maptalks-map(
			@mt-zoomend='handleMapZoomEnd',
			ref='map',
			:options='mapOptions',
			:pitch='pitch',
			:base='base'
		)
			maptalks-vector-layer
				maptalks-line-layer(
					v-for='(route, index) in routeList',
					:key='`line-${index}`',
					:coordinates='route.coordinates',

					:line-color='route.color'
				)
				template(v-if=`!$store.getters.is3D`)
					maptalks-marker(
						v-for='(bus, index) in $store.getters.busList',
						:key='`marker-${index}`',
						:coordinates='[bus.lng, bus.lat]',
						:heading='bus.heading',
						:speed='bus.speed'
					)
				maptalks-label(
					v-for='(bus, index) in $store.getters.busList',
					:key='`label-${index}`',
					:coordinates='[bus.lng, bus.lat]',
					:text-name='bus.name'
				)
			template(v-if=`$store.getters.is3D`)
				maptalks-three-layer
					maptalks-bus(
						v-for='(bus, index) in $store.getters.busList',
						:key='`bus-${index}`',
						:coordinates='{x: bus.lng, y: bus.lat}',
						:heading='bus.heading',
						:color='bus.color',
						:speed='bus.speed'
					)
</template>

<script>
import {
	MAP_BEARING,
  MAP_ZOOM,
  MAP_PITCH,
  MAP_MAX_PITCH,
  MAP_CENTER } from '@/app.config'
import MaptalksMap from '@/components/maptalks/Map'
import MaptalksThreeLayer from '@/components/maptalks/ThreeLayer'
import MaptalksVectorLayer from '@/components/maptalks/VectorLayer'
import MaptalksBus from '@/components/maptalks/Bus'
import MaptalksLabel from '@/components/maptalks/Label'
import MaptalksMarker from '@/components/maptalks/Marker'
import MaptalksLineLayer from '@/components/maptalks/LineLayer'
import api from '@/api'

export default {
	name: 'the-map',
	components: {
		MaptalksMap,
		MaptalksThreeLayer,
		MaptalksBus,
		MaptalksLineLayer,
		MaptalksVectorLayer,
		MaptalksLabel,
		MaptalksMarker
	},
	data () {
		return {
			routeList: []
		}
	},
	computed: {
		base () {
			return this.$store.getters.base
		},
		pitch () {
			return this.$store.getters.is3D ? MAP_PITCH : 0
		},
		mapOptions() {
			return {
				zoom: MAP_ZOOM,
				maxPitch: MAP_MAX_PITCH,
				center: MAP_CENTER,
				bearing: MAP_BEARING
				// dragPitch: false,
				// dragRotate: false
			}
		}
	},
	async created () {
		await this.getRouteList()
	},
	methods: {
		async getRouteList () {
			const { data } = await api.getRouteList()
			this.routeList = Object.freeze(data)
		},
		handleMapZoomEnd () {
		}
	}
}
</script>

<style scoped>
.the-map {
	width: 100%;
	height: 100%;
}
</style>